module.exports = __webpack_public_path__ + "static/media/diploma.bf0cab78.svg";